import { closeReconciliationURLs } from 'routes/close/closeURLs';

import { UserAvatar } from 'components/data-display/UserAvatar';

import { useUsersData } from 'hooks/useUsersData';

import { featureFlags } from 'utils/config/featureFlags';
import { getName } from 'utils/users/config';

import { useAuthStore } from 'store/auth.store';

import { GenericNotificationItem } from 'layout/inbox-notifications/GenericNotificationItem';

import type { ReconTaskCreatedNotification } from 'types/inbox-notifications/close/ReconciliationNotifications';

const { FF__SHOW_NOTIFICATIONS_DEBUG_MODE: DEBUG_MODE } = featureFlags;

export function CreatedNotificationItem({
  item,
}: {
  item: ReconTaskCreatedNotification;
}) {
  const { usersMap } = useUsersData();
  const { user } = useAuthStore();
  if (!item.task) {
    return <div>Reconciliation task not found</div>;
  }

  const actorName = getName(item.actor_id, usersMap);
  const viewerUserId = (DEBUG_MODE && item.debug_user_id) || user?.id;
  if (!viewerUserId) {
    return <div>User not found {DEBUG_MODE && viewerUserId}</div>;
  }

  const isPreparer = item.task.preparers.some(
    (preparer) => preparer.user_id === viewerUserId
  );
  const actorType = isPreparer ? 'preparer' : 'reviewer';

  return (
    <GenericNotificationItem
      item={item}
      url={closeReconciliationURLs.taskBase({
        taskId: item.task.core_snapshot.short_code,
      })}
      avatar={<UserAvatar userId={item.actor_id} />}
      title={`${actorName} assigned you a reconciliation as ${actorType}.`}
      description={<span>&quot;{item.task.core_snapshot.name}&quot;</span>}
    />
  );
}
